// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_mEE","name":"styles_name__2898Q","phone":"styles_phone__3qOPi"};